import { render, staticRenderFns } from "./MenuMovilStore.vue?vue&type=template&id=f98d7e54"
import script from "./MenuMovilStore.vue?vue&type=script&lang=js"
export * from "./MenuMovilStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports